import React from "react";

import svg from "../../assets/images/icons/edit_gray.svg";

export const EditGrayIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Edit"}
    />
);
